<template>
    <el-dialog :visible.sync="show" title="添加/修改">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="名称">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false">取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { selectImage, selectVideo } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgSuccess } from "../../util/toast";
export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null
        };
    },
    created() {},
    methods: {
        addOrEdit(item) {
            this.show = true;
            this.model = this.deepCopy({
                ...item
            });
        },
        async save() {
            this.loadingSave = true;
            // this.model = { ...this.model, masterAdmin: true };
            await HttpClient.put("/restful", {
                model: "House",
                cond: this.model._id,
                updates: this.model
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        }
    }
};
</script>

<style scoped lang="less">
</style>

        